<template>
  <div class="accepted-icon">
    <v-icon color="white" size="20">mdi-check-circle-outline</v-icon>
  </div>
</template>

<script>
export default {
  name: "AcceptedChip",
};
</script>

<style scoped>
.accepted-icon {
  background: linear-gradient(90deg, #43a047, #2e7d32);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
</style>
